<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs6>
        <h1>Staff (Archived)</h1>
      </v-flex>
      <v-flex xs6 class="text-right">
        <v-btn color="accent" outlined :to="'/management/users'">Active Staff</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="archivedUsers"
            item-key="name"
            class="elevation-1">
            <template v-slot:item.action="{ item }">
              <v-icon
                color="accent"
                class="mr-2"
                @click="restoreDialogForUser(item)">
                restore
              </v-icon>
              <v-icon color="error"
                      @click="deleteDialogForUser(item)">
                mdi-trash-can-outline
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <template>
        <v-row justify="center">
          <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline pt-1 pr-1">
                Confirm Deletion
                <v-spacer></v-spacer>
                <v-btn icon @click="deleteConfirmDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="pb-1"> Are you sure you want delete this staff member?</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn outlined color="error" @click="deleteMethod(user)">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <template>
        <v-row justify="center">
          <v-dialog v-model="restoreConfirmDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline pt-1 pr-1">
                Confirm Restore
                <v-spacer></v-spacer>
                <v-btn icon @click="restoreConfirmDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text> Are you sure you want restore this staff member?</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn outlined color="accent" @click="restoreMethod(user)">Restore</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'list-archived-users',
  created () {
    this.loadArchivedUsers()
  },
  data () {
    return {
      deleteConfirmDialog: false,
      restoreConfirmDialog: false,
      user: null
    }
  },
  methods: {
    ...mapActions({
      loadArchivedUsers: 'user/loadArchivedUsers',
      deleteUser: 'user/deleteUser',
      restoreUser: 'user/restoreUser'
    }),
    restoreDialogForUser (item) {
      this.restoreConfirmDialog = true
      this.user = item.user
    },
    deleteDialogForUser (item) {
      this.deleteConfirmDialog = true
      this.user = item.user
    },
    async restoreMethod (user) {
      this.restoreConfirmDialog = await this.restoreUser(user)
    },

    async deleteMethod (user) {
      this.deleteConfirmDialog = await this.deleteUser(user)
    }
  },
  computed: {
    ...mapGetters({
      archivedUsers: 'user/archivedUsers',
      headers: 'user/headers'
    })
  }
}
</script>
